import React, { useEffect, useMemo, useState } from "react";
import "./style.css";
import { DevicesOverview } from "../../Widgets";
import { ReactTable } from "../../Components/Molecules";
import { getSpecificDevDetails } from "../../APIs";
import { getFilters } from "../../Library/tableHelpers";
import { SHOW_DEALER_DEVICES_HEADERS } from "../../Library/tableHeaders";
import { Link } from "react-router-dom";
import PATHS from "../../Routes/paths";
import { PING_TEST_STATUS, PING_TEST_STATUS_VAL } from "../../Library/constants";

const InventoryOverview = () => {
  const [ dealerDevices, setDealerDevices ] = useState([]);

  useEffect(() => {
    getSpecificDevDetails(null, (err, data) => {
      if (err) console.error(err);
      else {
        data.forEach(dev => {
          if (dev.ptStat && dev.ptStat.st) {
            if (dev.ptStat.st === PING_TEST_STATUS_VAL["In Progress"] && dev.vid) {
              dev.pingTest = PING_TEST_STATUS[1];
            }
            else dev.pingTest = PING_TEST_STATUS[dev.ptStat.st];
          } else dev.pingTest = "Test Pending";
        });
        setDealerDevices(data);
      }
    });
  }, []);

  const columns = useMemo(() => {
    const cols = [];
    Object.values(SHOW_DEALER_DEVICES_HEADERS).forEach(header => {
        cols.push({
          Header: header.nm,
          accessor: header.key,
          disableSortBy: !header.sorting,
          ...getFilters(header),
          Cell: (row) => {
            if (row.column.id === "chNum") {
              return row.value || <p className="unmapped-cell-value">Unmapped</p>;
            }

            if (row.column.id === "imei") {
              return <Link to={`${PATHS.INVENTORY_OVERVIEW}/${PATHS.SPECIFIC_DEVICE}?imei=${row.value}`} className="imei-link-text">{row.value}</Link>
            }

            if (row.column.id === "pingTest") {
              return <p className={`${row.value === "In Progress" ? "in-progress-highlight" : row.value === "Tested" ? "tested-highlight" : ""}`}>{row.value}</p>
            }

            return row.value
          }
        });
    });

    return cols;
  }, []);

  return (
    <section className="panel-main inventory-overview">
      <DevicesOverview showIcons={true} />

      <div className="dealer-devices-table">
        <ReactTable
          data={dealerDevices}
          columns={columns}
          pageSize={10}
          showSearch={true}
        />
      </div>
    </section>
  )
}

export default InventoryOverview
